<template>
  <vjs-modal name="create-plan-modal" title="Create New Plan" icon="la la-plus-circle">
    <template slot="body-content">
      <ValidationObserver ref="observer">
        <b-form slot-scope="{ validate }" @submit.prevent="validate().then(createPlan)">
          <ValidationProvider rules="required|alpha_spaces" name="Label">
            <b-form-group slot-scope="{ valid, errors }" label="Plan name:">
              <b-form-input
                v-model="label"
                type="text"
                :state="errors[0] ? false : (valid ? true : null)"
                placeholder="Plan name..." />
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
        </b-form>
      </ValidationObserver>
    </template>

    <template slot="body-controls">
      <button type="button" class="btn btn-ss-standout" @click="createPlan">
        Create Plan
      </button>
      <button type="button" class="btn btn-ss-cancel" @click="closeModal">
        Close
      </button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
} from 'bootstrap-vue';

export default {
  components: {
    VjsModal,
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
  },
  data: () => ({
    label: null,
  }),
  methods: {
    createPlan() {
      axios.post('/api/v1/admin/plans', {
        'label': this.label,
      }).then((response) => {
        EventBus.$emit('plan_added', response.data.data);
        this.label = null;
        toastr.success(`Plan '${response.data.data.label}' created`);
        this.closeModal();
      }).catch((error) => {
        window.handleAxiosError(error);
      });
    },
    closeModal() {
      this.$modal.hide(`create-plan-modal`);
    },
  },
};
</script>
